import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Banner from '../sections/Banner';

interface LayoutProps {
  children: React.ReactNode;
}

const NAVBAR_HEIGHT = 100;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const navbarRef = useRef<HTMLDivElement>(null);
  const bannerRef = useRef<HTMLDivElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {}, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!navbarRef.current) return;

      let transformY = 0;

      // Handle banner offset on home page
      if (isHomePage && bannerRef.current) {
        const currentBannerHeight = bannerRef.current.offsetHeight;
        const scrollY = window.scrollY;
        transformY = Math.max(0, currentBannerHeight - scrollY);
      }

      // Handle footer overlap
      if (footerRef.current) {
        const footerRect = footerRef.current.getBoundingClientRect();
        if (footerRect.top <= NAVBAR_HEIGHT) {
          transformY = -NAVBAR_HEIGHT;
        }
      }

      navbarRef.current.style.transform = `translateY(${transformY}px)`;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  return (
    <div className="min-h-screen flex flex-col">
      {isHomePage && (
        <div ref={bannerRef}>
          <Banner />
        </div>
      )}

      <div
        ref={navbarRef}
        className="fixed top-0 left-0 right-0 z-50"
      >
        <Navbar />
      </div>

      {!isHomePage && <div style={{ height: `${NAVBAR_HEIGHT}px` }} />}

      <main className="flex-grow">
        {children}
      </main>

      <div ref={footerRef}>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
